import { Box, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { ReactComponent as NoDataIcon } from '../../../static/icons/tasklists/ic_no_data.svg';
import { useCommissions } from '../../../hooks/useCommissions';

const EmptyCommissionPlans = () => {
  const { t } = useTranslation('commissions');
  const { createCommission } = useCommissions();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      textAlign="center"
      padding={2}
    >
      <NoDataIcon style={{ width: '300px', height: '300px', marginBottom: '16px' }} />
      <Typography variant="h6" color="textSecondary">
        {t('youDoneHaveAny')}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {t('startByCreating')}
      </Typography>
      <Box pt={2}>
        <Button onClick={createCommission} variant="contained" color="primary">
          {t('createNewPlan')}
        </Button>
      </Box>
    </Box>
  );
};

export { EmptyCommissionPlans };
